import { useAppDispatch } from '../../../../state/hooks'
import { saleSubmittedEarly } from '../../../../state/slices/currentSale/currentSaleSlice'
import { useSaleManager } from '../../../../ng-compat/hooks'
import { $state } from '../../../../ng-compat/imports'
import { STATES } from '../../../../../../lib/routes'

export const useGoConfirmation = () => {
  const dispatch = useAppDispatch()
  const saleManager = useSaleManager()

  /**
   * Navigate to the sale confirmation screen.
   * If the sale should be submitted early, dispatch the saleSubmittedEarly action
   * and submit the sale before navigating.
   */
  const goConfirmation = () => {
    if (saleManager.shouldSubmitSaleEarly()) {
      dispatch(saleSubmittedEarly())
      saleManager.submitSale()
    }
    $state.go(STATES.SALE_CONFIRMATION)
  }

  return goConfirmation
}
